import { markRaw } from 'vue';
import { useToast } from 'vue-toastification';
import Toast from '../../molecules/Toast.vue';
import IconError from '../../icons/IconError.vue';
import i18n from '../../i18n';

export const toast = useToast();

export function showToast(title, description, type, buttonText = 'Close', icon = IconError, options = {}) {
  const toastId = toast(
    {
      component: markRaw(Toast),
      props: {
        title: title || i18n.global.t('toast.occuredSomeError'),
        description: description || i18n.global.t('toast.occuredSomeError'),
        buttonText,
        iconClasses: type === 'error' ? 'text-color-danger' : 'text-color-success',
        icon: icon ? markRaw(icon) : markRaw(IconError),
        onClose: () => toast.dismiss(toastId)
      }
    },
    {
      closeOnClick: false,
      hideProgressBar: true,
      icon: false,
      ...options
    }
  );
}

export function showToastLoading(title, description, type, buttonIcon = null, icon = IconError, options = {}) {
  const toastId = toast(
    {
      component: markRaw(Toast),
      props: {
        title: title || i18n.global.t('toast.occuredSomeError'),
        description: description || i18n.global.t('toast.occuredSomeError'),
        buttonIcon: buttonIcon ? markRaw(buttonIcon) : null,
        buttonIconClasses: 'text-color-primary-1',
        iconClasses: type === 'error' ? 'text-color-danger' : 'text-color-success',
        icon: icon ? markRaw(icon) : markRaw(IconError),
        onClose: () => toast.dismiss(toastId)
      }
    },
    {
      timeout: false,
      closeOnClick: false,
      hideProgressBar: true,
      icon: false,
      ...options
    }
  );
  return toastId;
}
